export enum Theme {
    light = "light",
    lightNanci = "light-nanci",
    dark = "dark",
    darkNanci = "dark-nanci"
}
